import { render, staticRenderFns } from "./IconStethoscope.vue?vue&type=template&id=484c430b"
import script from "./IconStethoscope.vue?vue&type=script&lang=js"
export * from "./IconStethoscope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports